import { FormEvent, useState } from 'react';
import { useAuth } from '../lib/auth';

export function Login() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      await login(password);
    } catch (err: any) {
      setErro('Senha incorreta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center p-4 bg-gradient-to-br from-brand-900 to-slate-900">
      <form onSubmit={submit} className="card-pad w-full max-w-sm space-y-4">
        <div className="text-center">
          <h1 className="text-xl font-bold text-slate-900">Aluguéis</h1>
          <p className="text-sm text-slate-500">Acesso restrito</p>
        </div>
        <div>
          <label className="label">Senha</label>
          <input
            type="password"
            autoFocus
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {erro && <p className="text-sm text-red-600">{erro}</p>}
        <button className="btn-primary w-full" disabled={loading || !password}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
